import { makeAutoObservable } from 'mobx'
import CustomVolumeMeasure from '@/components/Cesium/CustomMeasure/volume'

export class VolumeMeasure {
  constructor() {
    makeAutoObservable(this)
  }

  customMeasure: any = null

  drawTrianglesMeasureGraphicsVolume({ viewer, callback }: any) {
    let customMeasureCurr = null
    if (this.customMeasure === null) {
      customMeasureCurr = new CustomVolumeMeasure(viewer)
      this.customMeasure = customMeasureCurr
    }
    else {
      customMeasureCurr = this.customMeasure
    }
    customMeasureCurr.drawTrianglesMeasureGraphicsVolume({
      callback: (num: number) => callback(num),
    })
  }

  destroy() {
    if (this.customMeasure) {
      this.customMeasure.destroy()
      this.customMeasure = null
    }
  }
}
